import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/zoom-in.vue
var o = {
	name: "DtIconZoomIn",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--zoom-in"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Zoom In",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M1 5.5a4.5 4.5 0 1 1 8.016 2.81l1.838 1.838a.5.5 0 1 1-.707.707L8.309 9.016A4.5 4.5 0 0 1 1 5.5Zm1 0a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		d: "M5.5 3.5A.5.5 0 0 1 6 4v1h1a.5.5 0 1 1 0 1H6v1a.5.5 0 1 1-1 0V6H4a.5.5 0 0 1 0-1h1V4a.5.5 0 0 1 .5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=zoom-in.js.map